"use client";

import React, { useState, useEffect } from "react";
import { Link } from "@/components/common/Link";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";
import { Form, FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Loader as Loader2, CircleCheck as CheckCircle, CircleAlert as AlertCircle, Video, CloudUpload, Package } from 'lucide-react';
const countriesList = [{
  value: "afghanistan",
  label: "Afghanistan"
}, {
  value: "albania",
  label: "Albania"
}, {
  value: "algeria",
  label: "Algeria"
}, {
  value: "andorra",
  label: "Andorra"
}, {
  value: "angola",
  label: "Angola"
}, {
  value: "antigua_e_barbuda",
  label: "Antigua e Barbuda"
}, {
  value: "arabia_saudita",
  label: "Arabia Saudita"
}, {
  value: "argentina",
  label: "Argentina"
}, {
  value: "armenia",
  label: "Armenia"
}, {
  value: "australia",
  label: "Australia"
}, {
  value: "austria",
  label: "Austria"
}, {
  value: "azerbaigian",
  label: "Azerbaigian"
}, {
  value: "bahamas",
  label: "Bahamas"
}, {
  value: "bahrein",
  label: "Bahrein"
}, {
  value: "bangladesh",
  label: "Bangladesh"
}, {
  value: "barbados",
  label: "Barbados"
}, {
  value: "belgio",
  label: "Belgio"
}, {
  value: "belize",
  label: "Belize"
}, {
  value: "benin",
  label: "Benin"
}, {
  value: "bhutan",
  label: "Bhutan"
}, {
  value: "bielorussia",
  label: "Bielorussia"
}, {
  value: "bolivia",
  label: "Bolivia"
}, {
  value: "bosnia_ed_erzegovina",
  label: "Bosnia ed Erzegovina"
}, {
  value: "botswana",
  label: "Botswana"
}, {
  value: "brasile",
  label: "Brasile"
}, {
  value: "brunei",
  label: "Brunei"
}, {
  value: "bulgaria",
  label: "Bulgaria"
}, {
  value: "burkina_faso",
  label: "Burkina Faso"
}, {
  value: "burundi",
  label: "Burundi"
}, {
  value: "cambogia",
  label: "Cambogia"
}, {
  value: "camerun",
  label: "Camerun"
}, {
  value: "canada",
  label: "Canada"
}, {
  value: "capo_verde",
  label: "Capo Verde"
}, {
  value: "ceca_repubblica",
  label: "Ceca, Repubblica"
}, {
  value: "centrafricana_repubblica",
  label: "Centrafricana, Repubblica"
}, {
  value: "ciad",
  label: "Ciad"
}, {
  value: "cile",
  label: "Cile"
}, {
  value: "cina",
  label: "Cina"
}, {
  value: "cipro",
  label: "Cipro"
}, {
  value: "colombia",
  label: "Colombia"
}, {
  value: "comore",
  label: "Comore"
}, {
  value: "congo_repubblica_del",
  label: "Congo, Repubblica del"
}, {
  value: "congo_repubblica_democratica_del",
  label: "Congo, Repubblica Democratica del"
}, {
  value: "corea_del_nord",
  label: "Corea del Nord"
}, {
  value: "corea_del_sud",
  label: "Corea del Sud"
}, {
  value: "costa_d_avorio",
  label: "Costa d'Avorio"
}, {
  value: "costa_rica",
  label: "Costa Rica"
}, {
  value: "croazia",
  label: "Croazia"
}, {
  value: "cuba",
  label: "Cuba"
}, {
  value: "danimarca",
  label: "Danimarca"
}, {
  value: "dominica",
  label: "Dominica"
}, {
  value: "dominicana_repubblica",
  label: "Dominicana, Repubblica"
}, {
  value: "ecuador",
  label: "Ecuador"
}, {
  value: "egitto",
  label: "Egitto"
}, {
  value: "el_salvador",
  label: "El Salvador"
}, {
  value: "emirati_arabi_uniti",
  label: "Emirati Arabi Uniti"
}, {
  value: "eritrea",
  label: "Eritrea"
}, {
  value: "estonia",
  label: "Estonia"
}, {
  value: "etiopia",
  label: "Etiopia"
}, {
  value: "figi",
  label: "Figi"
}, {
  value: "filippine",
  label: "Filippine"
}, {
  value: "finlandia",
  label: "Finlandia"
}, {
  value: "francia",
  label: "Francia"
}, {
  value: "gabon",
  label: "Gabon"
}, {
  value: "gambia",
  label: "Gambia"
}, {
  value: "georgia",
  label: "Georgia"
}, {
  value: "germania",
  label: "Germania"
}, {
  value: "ghana",
  label: "Ghana"
}, {
  value: "giamaica",
  label: "Giamaica"
}, {
  value: "giappone",
  label: "Giappone"
}, {
  value: "gibuti",
  label: "Gibuti"
}, {
  value: "giordania",
  label: "Giordania"
}, {
  value: "grecia",
  label: "Grecia"
}, {
  value: "grenada",
  label: "Grenada"
}, {
  value: "guatemala",
  label: "Guatemala"
}, {
  value: "guinea",
  label: "Guinea"
}, {
  value: "guinea_bissau",
  label: "Guinea-Bissau"
}, {
  value: "guinea_equatoriale",
  label: "Guinea Equatoriale"
}, {
  value: "guyana",
  label: "Guyana"
}, {
  value: "haiti",
  label: "Haiti"
}, {
  value: "honduras",
  label: "Honduras"
}, {
  value: "india",
  label: "India"
}, {
  value: "indonesia",
  label: "Indonesia"
}, {
  value: "iran",
  label: "Iran"
}, {
  value: "iraq",
  label: "Iraq"
}, {
  value: "irlanda",
  label: "Irlanda"
}, {
  value: "islanda",
  label: "Islanda"
}, {
  value: "israele",
  label: "Israele"
}, {
  value: "italia",
  label: "Italia"
}, {
  value: "kazakistan",
  label: "Kazakistan"
}, {
  value: "kenya",
  label: "Kenya"
}, {
  value: "kirghizistan",
  label: "Kirghizistan"
}, {
  value: "kiribati",
  label: "Kiribati"
}, {
  value: "kuwait",
  label: "Kuwait"
}, {
  value: "laos",
  label: "Laos"
}, {
  value: "lesotho",
  label: "Lesotho"
}, {
  value: "lettonia",
  label: "Lettonia"
}, {
  value: "libano",
  label: "Libano"
}, {
  value: "liberia",
  label: "Liberia"
}, {
  value: "libia",
  label: "Libia"
}, {
  value: "liechtenstein",
  label: "Liechtenstein"
}, {
  value: "lituania",
  label: "Lituania"
}, {
  value: "lussemburgo",
  label: "Lussemburgo"
}, {
  value: "macedonia_del_nord",
  label: "Macedonia del Nord"
}, {
  value: "madagascar",
  label: "Madagascar"
}, {
  value: "malawi",
  label: "Malawi"
}, {
  value: "malesia",
  label: "Malesia"
}, {
  value: "maldive",
  label: "Maldive"
}, {
  value: "mali",
  label: "Mali"
}, {
  value: "malta",
  label: "Malta"
}, {
  value: "marocco",
  label: "Marocco"
}, {
  value: "marshall_isole",
  label: "Marshall, Isole"
}, {
  value: "mauritania",
  label: "Mauritania"
}, {
  value: "mauritius",
  label: "Mauritius"
}, {
  value: "messico",
  label: "Messico"
}, {
  value: "micronesia",
  label: "Micronesia"
}, {
  value: "moldavia",
  label: "Moldavia"
}, {
  value: "monaco",
  label: "Monaco"
}, {
  value: "mongolia",
  label: "Mongolia"
}, {
  value: "montenegro",
  label: "Montenegro"
}, {
  value: "mozambico",
  label: "Mozambico"
}, {
  value: "myanmar",
  label: "Myanmar"
}, {
  value: "namibia",
  label: "Namibia"
}, {
  value: "nauru",
  label: "Nauru"
}, {
  value: "nepal",
  label: "Nepal"
}, {
  value: "nicaragua",
  label: "Nicaragua"
}, {
  value: "niger",
  label: "Niger"
}, {
  value: "nigeria",
  label: "Nigeria"
}, {
  value: "norvegia",
  label: "Norvegia"
}, {
  value: "nuova_zelanda",
  label: "Nuova Zelanda"
}, {
  value: "oman",
  label: "Oman"
}, {
  value: "paesi_bassi",
  label: "Paesi Bassi"
}, {
  value: "pakistan",
  label: "Pakistan"
}, {
  value: "palau",
  label: "Palau"
}, {
  value: "panama",
  label: "Panama"
}, {
  value: "papua_nuova_guinea",
  label: "Papua Nuova Guinea"
}, {
  value: "paraguay",
  label: "Paraguay"
}, {
  value: "peru",
  label: "Perù"
}, {
  value: "polonia",
  label: "Polonia"
}, {
  value: "portogallo",
  label: "Portogallo"
}, {
  value: "qatar",
  label: "Qatar"
}, {
  value: "regno_unito",
  label: "Regno Unito"
}, {
  value: "romania",
  label: "Romania"
}, {
  value: "russia",
  label: "Russia"
}, {
  value: "rwanda",
  label: "Rwanda"
}, {
  value: "saint_kitts_e_nevis",
  label: "Saint Kitts e Nevis"
}, {
  value: "saint_lucia",
  label: "Saint Lucia"
}, {
  value: "saint_vincent_e_grenadine",
  label: "Saint Vincent e Grenadine"
}, {
  value: "samoa",
  label: "Samoa"
}, {
  value: "san_marino",
  label: "San Marino"
}, {
  value: "sao_tome_e_principe",
  label: "Sao Tomé e Principe"
}, {
  value: "senegal",
  label: "Senegal"
}, {
  value: "serbia",
  label: "Serbia"
}, {
  value: "seychelles",
  label: "Seychelles"
}, {
  value: "sierra_leone",
  label: "Sierra Leone"
}, {
  value: "singapore",
  label: "Singapore"
}, {
  value: "siria",
  label: "Siria"
}, {
  value: "slovacchia",
  label: "Slovacchia"
}, {
  value: "slovenia",
  label: "Slovenia"
}, {
  value: "solomone_isole",
  label: "Solomone, Isole"
}, {
  value: "somalia",
  label: "Somalia"
}, {
  value: "spagna",
  label: "Spagna"
}, {
  value: "sri_lanka",
  label: "Sri Lanka"
}, {
  value: "stati_uniti",
  label: "Stati Uniti"
}, {
  value: "sudafrica",
  label: "Sudafrica"
}, {
  value: "sudan",
  label: "Sudan"
}, {
  value: "sudan_del_sud",
  label: "Sudan del Sud"
}, {
  value: "suriname",
  label: "Suriname"
}, {
  value: "svezia",
  label: "Svezia"
}, {
  value: "svizzera",
  label: "Svizzera"
}, {
  value: "eswatini",
  label: "Eswatini"
}, {
  value: "tagikistan",
  label: "Tagikistan"
}, {
  value: "taiwan",
  label: "Taiwan"
}, {
  value: "tanzania",
  label: "Tanzania"
}, {
  value: "thailandia",
  label: "Thailandia"
}, {
  value: "timor_est",
  label: "Timor Est"
}, {
  value: "togo",
  label: "Togo"
}, {
  value: "tonga",
  label: "Tonga"
}, {
  value: "trinidad_e_tobago",
  label: "Trinidad e Tobago"
}, {
  value: "tunisia",
  label: "Tunisia"
}, {
  value: "turchia",
  label: "Turchia"
}, {
  value: "turkmenistan",
  label: "Turkmenistan"
}, {
  value: "tuvalu",
  label: "Tuvalu"
}, {
  value: "ucraina",
  label: "Ucraina"
}, {
  value: "uganda",
  label: "Uganda"
}, {
  value: "ungheria",
  label: "Ungheria"
}, {
  value: "uruguay",
  label: "Uruguay"
}, {
  value: "uzbekistan",
  label: "Uzbekistan"
}, {
  value: "vanuatu",
  label: "Vanuatu"
}, {
  value: "vaticano_citta_del",
  label: "Vaticano, Città del"
}, {
  value: "venezuela",
  label: "Venezuela"
}, {
  value: "vietnam",
  label: "Vietnam"
}, {
  value: "yemen",
  label: "Yemen"
}, {
  value: "zambia",
  label: "Zambia"
}, {
  value: "zimbabwe",
  label: "Zimbabwe"
}];
const practiceTypes = [{
  value: "altro-servizio",
  label: "Altro Servizio"
}, {
  value: "apostille",
  label: "Apostille"
}, {
  value: "assicurazione-per-permesso-di-soggiorno",
  label: "Assicurazione per Permesso di Soggiorno"
}, {
  value: "assicurazione-per-studenti",
  label: "Assicurazione per Studenti"
}, {
  value: "assicurazione-sanitaria-per-visto",
  label: "Assicurazione Sanitaria per Visto"
}, {
  value: "assicurazione-viaggio-schengen",
  label: "Assicurazione Viaggio Schengen"
}, {
  value: "assistenza-pratica-cittadinanza",
  label: "Assistenza Pratica Cittadinanza"
}, {
  value: "assunzione-lavoratori-stranieri",
  label: "Assunzione Lavoratori Stranieri"
}, {
  value: "cimea",
  label: "CIMEA"
}, {
  value: "coesione-familiare",
  label: "Coesione Familiare"
}, {
  value: "consulenza-aggiornamento-permesso-di-soggiorno",
  label: "Consulenza Aggiornamento Permesso di Soggiorno"
}, {
  value: "consulenza-conversione-permesso-di-soggiorno",
  label: "Consulenza Conversione Permesso di Soggiorno"
}, {
  value: "consulenza-e-assistenza-cittadinanza-italiana-per-matrimonio",
  label: "Consulenza e Assistenza Cittadinanza Italiana per Matrimonio"
}, {
  value: "consulenza-e-assistenza-cittadinanza-italiana-per-residenza",
  label: "Consulenza e Assistenza Cittadinanza Italiana per Residenza"
}, {
  value: "consulenza-e-assistenza-decreto-flussi",
  label: "Consulenza e Assistenza Decreto Flussi"
}, {
  value: "consulenza-e-assistenza-dimostrazione-mezzi-economici",
  label: "Consulenza e Assistenza Dimostrazione Mezzi Economici"
}, {
  value: "consulenza-e-assistenza-iscrizione-anagrafica",
  label: "Consulenza e Assistenza Iscrizione Anagrafica"
}, {
  value: "consulenza-e-assistenza-riacquisto-della-cittadinanza-italiana",
  label: "Consulenza e Assistenza Riacquisto della Cittadinanza Italiana"
}, {
  value: "consulenza-e-assistenza-riconoscimento-cittadinanza-italiana-jure-sanguinis",
  label: "Consulenza e Assistenza Riconoscimento Cittadinanza Italiana Jure Sanguinis"
}, {
  value: "consulenza-emigrazione",
  label: "Consulenza Emigrazione"
}, {
  value: "consulenza-equipollenza-titoli-di-studio",
  label: "Consulenza Equipollenza Titoli di Studio"
}, {
  value: "consulenza-immigrazione",
  label: "Consulenza Immigrazione"
}, {
  value: "consulenza-mobilita-internazionale",
  label: "Consulenza Mobilità Internazionale"
}, {
  value: "consulenza-permesso-di-soggiorno",
  label: "Consulenza Permesso di Soggiorno"
}, {
  value: "consulenza-rinnovo-permesso-di-soggiorno",
  label: "Consulenza Rinnovo Permesso di Soggiorno"
}, {
  value: "conversione-da-lavoro-stagionale-a-non-stagionale",
  label: "Conversione da Lavoro Stagionale a Non Stagionale"
}, {
  value: "conversione-da-studio-a-lavoro",
  label: "Conversione da Studio a Lavoro"
}, {
  value: "dichiarazione-di-ospitalita",
  label: "Dichiarazione di Ospitalità"
}, {
  value: "dichiarazione-di-valore",
  label: "Dichiarazione di Valore"
}, {
  value: "fideiussione-bancaria",
  label: "Fideiussione Bancaria"
}, {
  value: "garanzia-bancaria-per-visto",
  label: "Garanzia Bancaria per Visto"
}, {
  value: "invito-per-turismo",
  label: "Invito per Turismo"
}, {
  value: "legalizzazione-consolare",
  label: "Legalizzazione Consolare"
}, {
  value: "legalizzazione-documenti",
  label: "Legalizzazione Documenti"
}, {
  value: "lettera-di-invito",
  label: "Lettera di Invito"
}, {
  value: "nulla-osta-al-lavoro",
  label: "Nulla Osta al Lavoro"
}, {
  value: "nulla-osta-al-ricongiungimento-familiare",
  label: "Nulla Osta al Ricongiungimento Familiare"
}, {
  value: "permesso-di-soggiorno-ue-per-soggiornanti-di-lungo-periodo",
  label: "Permesso di Soggiorno UE per Soggiornanti di Lungo Periodo"
}, {
  value: "pianificazione-trasferimento-all-estero",
  label: "Pianificazione Trasferimento all'Estero"
}, {
  value: "pianificazione-trasferimento-in-italia",
  label: "Pianificazione Trasferimento in Italia"
}, {
  value: "residenza-in-italia",
  label: "Residenza in Italia"
}, {
  value: "ricongiungimento-coniuge",
  label: "Ricongiungimento Coniuge"
}, {
  value: "ricongiungimento-familiare",
  label: "Ricongiungimento Familiare"
}, {
  value: "ricongiungimento-figli",
  label: "Ricongiungimento Figli"
}, {
  value: "ricongiungimento-genitori",
  label: "Ricongiungimento Genitori"
}, {
  value: "riconoscimento-titoli-esteri",
  label: "Riconoscimento Titoli Esteri"
}, {
  value: "traduzioni-asseverate",
  label: "Traduzioni Asseverate"
}, {
  value: "traduzioni-certificate",
  label: "Traduzioni Certificate"
}, {
  value: "traduzioni-giurate",
  label: "Traduzioni Giurate"
}, {
  value: "traduzioni-legalizzate",
  label: "Traduzioni Legalizzate"
}, {
  value: "visto-adozione-internazionale",
  label: "Visto per Adozione Internazionale"
}, {
  value: "visto-affari",
  label: "Visto Affari"
}, {
  value: "visto-cure-mediche",
  label: "Visto per Cure Mediche"
}, {
  value: "visto-investitori",
  label: "Visto per Investitori"
}, {
  value: "visto-lavoro-autonomo",
  label: "Visto Lavoro Autonomo"
}, {
  value: "visto-lavoro-qualificato",
  label: "Visto lavoro Qualificato"
}, {
  value: "visto-lavoro-subordinato",
  label: "Visto Lavoro Subordinato"
}, {
  value: "visto-motivi-religiosi",
  label: "Visto per Motivi Religiosi"
}, {
  value: "visto-nomadi-digitali",
  label: "Visto per Nomadi Digitali"
}, {
  value: "visto-reingresso-italia",
  label: "Visto Reingresso in Italia"
}, {
  value: "visto-ricerca-scientifica",
  label: "Visto per Ricerca Scientifica"
}, {
  value: "visto-ricongiungimento-familiare-ue",
  label: "Visto per Ricongiungimento Familiare UE"
}, {
  value: "visto-studio",
  label: "Visto Studio"
}, {
  value: "visto-turistico",
  label: "Visto Turistico"
}];
function SectionHeader({
  title
}: {
  title: string;
}) {
  return <div className="pt-4 pb-2 border-t border-border/50 mt-6 first:mt-0 first:border-t-0">
      <h3 className="text-sm font-bold tracking-wider text-primary uppercase mb-4">{title}</h3>
    </div>;
}
function PracticeFormInner() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  useEffect(() => {
    if (isSubmitted && !submitError) {
      const timer = setTimeout(() => {
        window.location.href = '/worldimmigrationvideo/';
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isSubmitted, submitError]);
  if (isSubmitted && !submitError) {
    return <Alert className="bg-green-50 border-green-200 text-green-900 dark:bg-green-950/50 dark:border-green-900 dark:text-green-200 py-8 flex flex-col items-center justify-center text-center space-y-4">
        <CheckCircle className="size-12 text-green-600 dark:text-green-400 mb-2" />
        <AlertTitle className="text-2xl font-default font-semibold">Richiesta Inviata</AlertTitle>
        <AlertDescription className="text-base">
          {successMessage}
        </AlertDescription>
        <Link to="https://worldimmigration.it/worldimmigrationvideo/" newTab className="mt-6 bg-[#FFC829] text-primary font-bold py-4 px-8 rounded-lg hover:bg-[#FFC829]/90 transition-colors text-center inline-block">
          Prenota la tua Video Consulenza
        </Link>
      </Alert>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6">
      <SectionHeader title="DATI ANAGRAFICI" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField control={control} name="nome" rules={{
        required: "Il nome è obbligatorio"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Nome</FormLabel>
              <FormControl>
                <Input className="bg-[#ADD8E6] text-primary" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="cognome" rules={{
        required: "Il cognome è obbligatorio"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Cognome</FormLabel>
              <FormControl>
                <Input className="bg-[#ADD8E6] text-primary" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <FormField control={control} name="codice_fiscale" rules={{
      required: "Il codice fiscale è obbligatorio",
      pattern: {
        value: /^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/i,
        message: "Inserisci un codice fiscale valido"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel>Codice Fiscale</FormLabel>
            <FormControl>
              <Input className="bg-[#ADD8E6] text-primary uppercase" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <SectionHeader title="DATI DI CONTATTO" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField control={control} name="telefono" rules={{
        required: "Il numero di telefono è obbligatorio"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Telefono</FormLabel>
              <FormControl>
                <Input type="tel" className="bg-[#ADD8E6] text-primary" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="email" rules={{
        required: "L'email è obbligatoria",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Inserisci un indirizzo email valido"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Email</FormLabel>
              <FormControl>
                <Input type="email" className="bg-[#ADD8E6] text-primary" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <SectionHeader title="INDIRIZZO" />
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <div className="md:col-span-3">
          <FormField control={control} name="via" rules={{
          required: "La via è obbligatoria"
        }} render={({
          field
        }) => <FormItem>
                <FormLabel>Via/Piazza</FormLabel>
                <FormControl>
                  <Input className="bg-[#ADD8E6] text-primary" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>} />
        </div>
        <FormField control={control} name="numero_civico" rules={{
        required: "Obbligatorio"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Civico</FormLabel>
              <FormControl>
                <Input className="bg-[#ADD8E6] text-primary" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <FormField control={control} name="comune" rules={{
        required: "Il comune è obbligatorio"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Comune</FormLabel>
              <FormControl>
                <Input className="bg-[#ADD8E6] text-primary" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
        <FormField control={control} name="cap" rules={{
        required: "Il CAP è obbligatorio",
        pattern: {
          value: /^\d{5}$/,
          message: "CAP non valido"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>CAP</FormLabel>
              <FormControl>
                <Input className="bg-[#ADD8E6] text-primary" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
        <FormField control={control} name="provincia" rules={{
        required: "La provincia è obbligatoria"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Provincia</FormLabel>
              <FormControl>
                <Input className="bg-[#ADD8E6] text-primary uppercase" maxLength={2} {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <SectionHeader title="SERVIZIO RICHIESTO" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField control={control} name="paese_richiesta" rules={{
        required: "Il paese di destinazione/richiesta è obbligatorio"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Paese della Richiesta</FormLabel>
              <Select onValueChange={field.onChange} defaultValue={field.value}>
                <FormControl>
                  <SelectTrigger className="bg-[#ADD8E6] text-primary">
                    <SelectValue placeholder="Seleziona un paese" />
                  </SelectTrigger>
                </FormControl>
                <SelectContent className="bg-[#ADD8E6] text-primary">
                  {[...countriesList].sort((a, b) => a.label.localeCompare(b.label)).map((country, i) => <SelectItem key={country.value} value={country.value} data-index={i}>
                        {country.label}
                      </SelectItem>)}
                </SelectContent>
              </Select>
              <FormMessage />
            </FormItem>} />
      </div>

      <FormField control={control} name="tipo_pratica" rules={{
      required: "Seleziona il tipo di pratica"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel>Tipo di Pratica</FormLabel>
            <Select onValueChange={field.onChange} defaultValue={field.value}>
              <FormControl>
                <SelectTrigger className="bg-[#ADD8E6] text-primary">
                  <SelectValue placeholder="Seleziona un servizio" />
                </SelectTrigger>
              </FormControl>
              <SelectContent className="bg-[#ADD8E6] text-primary">
                {[...practiceTypes].sort((a, b) => a.label.localeCompare(b.label)).map((type, i) => <SelectItem key={type.value} value={type.value} data-index={i}>
                      {type.label}
                    </SelectItem>)}
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="modalita_consegna" rules={{
      required: "Seleziona la modalità di consegna"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel>Modalità di Consegna Documenti</FormLabel>
            <Select onValueChange={field.onChange} defaultValue={field.value}>
              <FormControl>
                <SelectTrigger className="bg-[#ADD8E6] text-primary">
                  <SelectValue placeholder="Seleziona modalità" />
                </SelectTrigger>
              </FormControl>
              <SelectContent className="bg-[#ADD8E6] text-primary">
                <SelectItem value="ritiro_sede">Ritiro in Sede</SelectItem>
                <SelectItem value="corriere_nazionale">Corriere Espresso Nazionale</SelectItem>
                <SelectItem value="corriere_internazionale">Corriere Espresso Internazionale</SelectItem>
                <SelectItem value="digitale">Solo formato digitale (se applicabile)</SelectItem>
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>} />

      <SectionHeader title="NOTE AGGIUNTIVE" />
      <FormField control={control} name="note_aggiuntive" render={({
      field
    }) => <FormItem>
            <FormLabel>Note Aggiuntive (Opzionale)</FormLabel>
            <FormControl>
              <Textarea className="min-h-[100px] bg-[#ADD8E6] text-primary" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="privacy_acceptance" rules={{
      required: "Devi accettare l'informativa sulla privacy per procedere"
    }} render={({
      field
    }) => <Dialog open={isPrivacyOpen} onOpenChange={setIsPrivacyOpen}>
            <FormItem className="flex flex-row items-start space-x-3 space-y-0 rounded-md border p-4 bg-muted/50">
              <FormControl>
                <Checkbox checked={field.value} onCheckedChange={field.onChange} className="bg-blue-100 border-2 border-black" />
              </FormControl>
              <div className="space-y-1 leading-none">
                <FormLabel className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
                   Ho letto l'Informativa Privacy e autorizzo il trattamento dei miei dati personali per la gestione della mia richiesta.
                </FormLabel>
                <DialogTrigger asChild>
                  <Button variant="link" className="text-xs text-primary hover:underline text-left block p-0 h-auto">
                    Leggi l'informativa sulla privacy completa
                  </Button>
                </DialogTrigger>
                <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto bg-card border-border">
                  <DialogHeader>
                    <DialogTitle className="text-xl font-bold text-primary">Informativa sulla Privacy (GDPR)</DialogTitle>
                  </DialogHeader>
                  <div className="space-y-4 text-sm text-muted-foreground py-4">
                    <div className="font-bold text-primary">
                      Titolare del Trattamento: WORLD IMMIGRATION DI DELGADO<br />
                      Sede: Via Roma 123, 00100 Roma (RM)<br />
                      Email: privacy@worldimmigration.it
                    </div>
                    <p>
                      Ai sensi del Regolamento UE 2016/679 (GDPR), la informiamo che i suoi dati personali saranno trattati per le seguenti finalità:
                    </p>
                    <ol className="list-decimal pl-5 space-y-2">
                      <li><strong>Finalità del trattamento:</strong> I dati raccolti tramite questo modulo sono necessari per l'elaborazione della sua richiesta di pratica o visto, la gestione della consulenza e l'eventuale esecuzione del contratto di servizio.</li>
                      <li><strong>Base giuridica:</strong> Il trattamento si fonda sull'esecuzione di misure precontrattuali o contrattuali e sul suo consenso esplicito.</li>
                      <li><strong>Conservazione dei dati:</strong> I dati saranno conservati per il tempo strettamente necessario all'espletamento della pratica e per i successivi obblighi di legge (solitamente 10 anni per documenti fiscali/contrattuali).</li>
                      <li><strong>Destinatari dei dati:</strong> I dati potranno essere comunicati a autorità consolari, ambasciate, corrieri per la consegna documenti e professionisti incaricati della gestione della pratica.</li>
                    </ol>
                    <p className="pt-4 border-t">
                      Per maggiori informazioni o per esercitare i propri diritti, scrivere a: <strong>privacy@worldimmigration.it</strong>
                    </p>
                  </div>
                </DialogContent>
                <FormMessage />
              </div>
            </FormItem>
          </Dialog>} />

      <FormField control={control} name="marketing_consent" render={({
      field
    }) => <FormItem className="flex flex-row items-start space-x-3 space-y-0 rounded-md border p-4 bg-muted/50">
            <FormControl>
              <Checkbox checked={field.value} onCheckedChange={field.onChange} className="bg-blue-100 border-2 border-black" />
            </FormControl>
            <div className="space-y-1 leading-none">
              <FormLabel className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
                 Acconsento a ricevere offerte, novità e comunicazioni promozionali da WORLD IMMIGRATION DI DELGADO.
              </FormLabel>
            </div>
          </FormItem>} />

      {submitError && <Alert variant="destructive">
          <AlertCircle className="size-4" />
          <AlertTitle>Errore</AlertTitle>
          <AlertDescription>{submitError}</AlertDescription>
        </Alert>}

      <div className="pt-4 border-t flex flex-col items-center space-y-4">
        <Button type="submit" size="lg" disabled={isSubmitting} className="w-full md:w-auto min-w-[200px] bg-primary text-primary-foreground hover:bg-primary/90">
          {isSubmitting ? <>
              <Loader2 className="mr-2 size-4 animate-spin" />
              Invio in corso...
            </> : "Invia richiesta"}
        </Button>
        <p className="text-xs text-muted-foreground text-center">
          I dati sono trattati secondo il Regolamento UE 2016/679
        </p>
      </div>
    </Form>;
}
export default function RequestForm() {
  const steps = [{
    numero: "01",
    icona: CheckCircle,
    titolo: "COMPILA IL MODULO:",
    testo: "Inserisci i tuoi dati e seleziona il tipo di pratica."
  }, {
    numero: "02",
    icona: Video,
    titolo: "FISSA UNA VIDEO CONSULENZA",
    testo: "Fissiamo una call per verificare fattibilità e requisiti."
  }, {
    numero: "03",
    icona: CloudUpload,
    titolo: "CARICA I DOCUMENTI:",
    testo: "Dopo la consulenza ricevi il link sicuro per accedere alla tua area cliente, caricare i documenti ed effettuare il pagamento."
  }, {
    numero: "04",
    icona: Package,
    titolo: "RICEVI LA PRATICA O VISTO A CASA",
    testo: "Elaboriamo tutto noi. Ricevi la tua Pratica o Visto pronto direttamente al tuo indirizzo."
  }];
  return <section id="online-practice-request-form" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl">
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-3xl md:text-4xl font-default font-bold text-primary">
            Come Funziona il Servizio Online
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Un processo semplificato, digitale e sicuro per gestire le tue pratiche internazionali ovunque tu sia.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-20 relative items-stretch">
          {steps.map((step, i) => <div key={i} data-index={i} className="relative group flex">
              {i < steps.length - 1 && <div className="hidden md:block absolute top-1/4 left-[80%] w-full border-t-2 border-dashed border-primary/20 z-0" />}
              <Card className="relative z-10 bg-blue-900 border border-white/10 rounded-lg p-6 md:p-8 transition-all duration-300 hover:scale-105 hover:border-[#FFC829]/50 hover:shadow-[0_0_20px_rgba(255,200,41,0.15)] animate-in fade-in slide-in-from-bottom-8 w-full h-full" style={{
            animationDelay: `${i * 150}ms`,
            animationFillMode: 'both'
          }}>
                <CardContent className="p-0 flex flex-col items-center space-y-6 h-full">
                  <div className="flex justify-between items-center w-full">
                    <div className="size-12 rounded-lg bg-primary/10 flex items-center justify-center">
                      <step.icona className="size-6 text-[#FFC829]" />
                    </div>
                    <span className="text-lg font-bold text-[#FFC829] bg-[#FFC829]/10 px-3 py-1 rounded-lg animate-pulse">
                      STEP {step.numero}
                    </span>
                  </div>
                  <div className="space-y-3 flex-grow">
                    <h3 className="text-xl font-bold text-white text-center">{step.titolo}</h3>
                    <p className="text-sm text-slate-300 leading-relaxed text-center">
                      {step.testo}
                    </p>
                  </div>
                </CardContent>
              </Card>
            </div>)}
        </div>

        <div className="max-w-4xl mx-auto">
          <Card className="border-border shadow-lg shadow-primary/5">
            <CardHeader className="bg-muted/30 border-b pb-6">
              <CardTitle className="text-xl font-default text-primary">Dettagli Pratica</CardTitle>
              <CardDescription>
                Compila tutti i campi obbligatori per permetterci di elaborare la tua richiesta nel minor tempo possibile.
              </CardDescription>
            </CardHeader>
            <CardContent className="pt-8">
              <FormProvider formId="pratica_online_request_form" sectionName="online-practice-request-form" defaultValues={{
              nome: "",
              cognome: "",
              codice_fiscale: "",
              telefono: "",
              email: "",
              via: "",
              numero_civico: "",
              comune: "",
              cap: "",
              provincia: "",
              paese_richiesta: "",
              tipo_pratica: "",
              modalita_consegna: "",
              note_aggiuntive: "",
              privacy_acceptance: false,
              marketing_consent: false
            }} submitText="Invia richiesta" successMessage={"Grazie! Abbiamo ricevuto la tua richiesta.\n\nORA CLICCA SOTTO PER FISSARE LA TUA VIDEO CONSULENZA"}>
                <PracticeFormInner />
              </FormProvider>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}